import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import selectn from "selectn";
import { Link } from "react-router-dom";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import generateRelativeHref from "utils/generateRelativeHref";

import styles from "./MiniStoryCard.css";
import { HeaderContext } from "../../../config/contexts";

class MiniStoryCard extends Component {
  render() {
    const { className, latest, storyCardRef } = this.props;
    if (!latest) return null;
    const section =
      latest.content_type === "newsletter"
        ? "Newsletters"
        : selectn("primary_section.name", latest);
    const publishedDateFormatted = formatPublishedDate(latest);
    const divider =
      (latest.is_featured || publishedDateFormatted) && section && " / ";

    return (
      <HeaderContext.Consumer>
        {headerLevels => {
          const HeadingTag = "h" + headerLevels.miniStoryCardHeader;
          return (
            <div key={latest.id} className={styles.root}>
              <Link
                innerRef={storyCardRef}
                className={classNames(styles.headline, className)}
                to={generateRelativeHref(latest.permalink)}
              >
                <HeadingTag className={styles.headline}>
                  {latest.headline}
                </HeadingTag>
              </Link>
              <div className={styles.subtext}>
                {latest.is_featured ? (
                  <span className={styles.featured}>Featured</span>
                ) : (
                  publishedDateFormatted
                )}
                {divider}
                {section}
              </div>
            </div>
          );
        }}
      </HeaderContext.Consumer>
    );
  }
}

MiniStoryCard.propTypes = {
  className: PropTypes.string,
  latest: PropTypes.shape({
    headline: PropTypes.string,
    id: PropTypes.string,
    is_featured: PropTypes.bool,
    permalink: PropTypes.string,
    published_date: PropTypes.string,
    status: PropTypes.string,
  }),
  storyCardRef: PropTypes.object,
};

export default MiniStoryCard;
